<template>
	<div
		class="table-container px-2 mt-4"
		@dragleave="dragLeave"
		@dragover.prevent="dragOver"
		@drop.prevent="dropFile"
	>
		<p class="text-body-2">
			<span>※ドラッグ＆ドロップでもファイルを添付できます。</span>
			<br />
			<span>※保存されるファイルの種類は現在一覧表示している種類になります。</span>
		</p>
		<v-data-table
			class="mt-4"
			:class="{ enter: isEnter, 'drag-drop-area': true }"
			locale="ja-JP"
			:headers="headers"
			:items="attached_files"
			:mobile-breakpoint="240"
			hide-default-footer
			disable-filtering
			disable-pagination
			disable-sort
			no-data-text="登録されたファイルはありません。"
		>
			<template v-slot:item="{ item }">
				<tr :key="item.id" class="no-click">
					<td>
						<a :href="item.url" target="_blank">{{ item.name }}</a>
					</td>
					<td>
						{{ item.type_tag ? item.type_tag.name : "" }}
					</td>
					<td>
						{{ item.user.full_name }}
					</td>
					<td class="text-center">
						<template v-if="authority_flag">
							<TemplateDeleteDialog ref="deleteDialog" onlyIcon>
								<template v-slot:button>
									<v-btn class="ma-1" dense dark color="red" @click="deleteFile(item.id)">
										削除する</v-btn
									>
								</template>
							</TemplateDeleteDialog>
						</template>
					</td>
				</tr>
			</template>
			<template v-slot:no-data
				><div @click="$emit('open-file-select')">
					登録されたファイルはありません。<br /><br />
					ドラッグ＆ドロップ、または、ここをクリックするとファイルを追加できます。
				</div>
			</template>
		</v-data-table>
		<PaginationModule
			:pagination="pagination"
			@get-page="$emit('get-page', $event)"
		></PaginationModule>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"
import PaginationModule from "../shared/PaginationModule.vue"

export default {
	props: {
		attached_files: {
			type: Array,
		},
		pagination: {
			type: Object,
		},
		authority_flag: {
			type: Boolean,
		},
		id: {
			type: Number || null,
		},
	},
	components: {
		TemplateDeleteDialog,
		PaginationModule,
	},
	data() {
		return {
			isEnter: false,
			files: [],
			headers: [
				{ text: "ファイル名", value: "", width: "600px" },
				{ text: "ファイルの種類", value: "", width: "300px" },
				{ text: "登録者", value: "", width: "200px" },
				{ text: "", value: "", width: "50px" },
			],
		}
	},
	methods: {
		dragLeave() {
			this.isEnter = false
		},
		dragOver() {
			this.isEnter = true
		},
		dropFile(event) {
			this.isEnter = false
			const files = [...event.dataTransfer.files]
			this.$emit("drop-files", files)
		},
		deleteFile(id) {
			const headers = authenticate.setHeader()
			axios
				.delete(`/erp/v1/matters/${this.id}/attached_files/${id}`, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "ファイルを削除しました",
						type: "notice",
					})
					this.$refs.deleteDialog.closeDialog()
					this.$emit("get-page", this.pagination.current)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		id(newVal, _) {
			this.id = newVal
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/variable.scss";
.enter {
	border: 5px solid $sub-color;
}
</style>
